<template>
  <section>
    <v-dialog
      v-model="dialog"
      max-width="700px"
    >
      <v-card
        shaped
        color="#ECEFF1"
      >
        <br>
        <h2 class="title-style">
          <v-icon class="icon-style">
            mdi-pencil
          </v-icon>Create Ticker Settings
        </h2>
        <v-card-text>
          <v-form
            ref="form"
            v-model="isFormValid"
          >
            <v-container>
              <v-row class="text-center">
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="name"
                    label="Setting Name*"
                    :rules="[(v) => !!v || 'This field is required']"
                  />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col
                  cols="12"
                  md="6"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="title"
                    :items="titlePositions"
                    label="Title Position*"
                    :rules="[(v) => !!v || 'This field is required']"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="tickerPosition"
                    :items="tickerPositionValues"
                    label="Ticker Position*"
                    :rules="[(v) => !!v || 'This field is required']"
                  />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col
                  cols="12"
                  md="6"
                  sm="6"
                >
                  <v-text-field
                    v-model="speed"
                    label="Speed*"
                    type="number"
                    :rules="[(v) => !!v || 'This field is required']"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="direction"
                    :items="tickerDirections"
                    label="Direction*"
                    :rules="[(v) => !!v || 'This field is required']"
                  />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col
                  cols="12"
                  md="6"
                  sm="6"
                >
                  <v-dialog
                    ref="menu"
                    v-model="showBgColorDialog"
                    :return-value.sync="backgroundColor"
                    width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="backgroundColor"
                        label="Background Color*"
                        prepend-icon=" mdi-palette"
                        readonly
                        v-bind="attrs"
                        :rules="[(v) => !!v || 'This field is required']"
                        v-on="on"
                      />
                    </template>
                    <v-color-picker
                      v-model="selectedBgColor"
                      show-swatches
                      full-width
                    />
                    <v-spacer />
                    <div>
                      <v-btn
                        color="black"
                        text
                        class="my-btn-style"
                        @click="showBgColorDialog = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="black"
                        text
                        class="my-btn-style"
                        @click="backgroundColor=$refs.menu.save(selectedBgColor)"
                      >
                        OK
                      </v-btn>
                    </div>
                  </v-dialog>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  sm="6"
                >
                  <v-dialog
                    ref="textColorPick"
                    v-model="showTextColorDialog"
                    :return-value.sync="textColor"
                    width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="textColor"
                        label="Text Color*"
                        prepend-icon=" mdi-palette"
                        readonly
                        v-bind="attrs"
                        :rules="[(v) => !!v || 'This field is required']"
                        v-on="on"
                      />
                    </template>
                    <v-color-picker
                      v-model="selectedTextColor"
                      show-swatches
                      full-width
                    />
                    <v-spacer />
                    <div>
                      <v-btn
                        color="black"
                        text
                        class="my-btn-style"
                        @click="showTextColorDialog = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="black"
                        text
                        class="my-btn-style"
                        @click="textColor =$refs.textColorPick.save(selectedTextColor)"
                      >
                        OK
                      </v-btn>
                    </div>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-container>
            <br>
            <p class="text-sm-left">
              *Indicates required field
            </p>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red darken-3"
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            color="#FF3700"
            @click="submit()"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
      <centre-spinner
        :loading="loading"
      />
    </v-dialog>
    <br>
  </section>
</template>

<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  export default {
    name: 'CreateTickerSettings',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        isFormValid: false,
        rules: {
          select: [(v) => !!v || 'This field is required'],
        },
        dialog: true,
        tickerPositionValues: ['Top', 'Bottom'],
        tickerDirections: ['Left', 'Right'],
        title: '',
        tickerPosition: '',
        speed: '',
        direction: '',
        backgroundColor: '',
        textColor: '',
        showBgColorDialog: false,
        showTextColorDialog: false,
        titlePositions: ['Before', 'After'],
        loading: false,
        selectedTextColor: '',
        selectedBgColor: '',
        name: null,
      };
    },
    watch: {
      dialog: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    methods: {
      async submit () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        this.$store.dispatch('widgets/createTickerSettings', {
          name: this.name,
          title: this.title.toLowerCase(),
          position: this.tickerPosition.toLowerCase(),
          speed: parseInt(this.speed),
          direction: this.direction.toLowerCase(),
          bg_color: this.backgroundColor,
          text_color: this.textColor,
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Ticker Setting created successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.loading = false;
          this.$emit('fetch-ticker-settings-list');
          this.dialog = false;
        }).catch(() => {
          this.loading = false;
        });
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-dialog > * {
  width: auto;
}
.my-btn-style {
  margin-right: 0px !important;
  width: 50%;
  border-radius: inherit;
  margin-bottom: 0px !important;
  background-color: #ffffff;
}
</style>
